export function createPeerConnection() {
  return new RTCPeerConnection({
    iceServers: [{ urls: 'stun:stun.l.google.com:19302' }, { urls: 'stun:stun1.l.google.com:19302' }],
  });
}

export async function getCallMedia(mode: 'voice' | 'video') {
  if (!navigator.mediaDevices?.getUserMedia) {
    throw new Error('This browser does not support microphone or camera access.');
  }

  try {
    return await navigator.mediaDevices.getUserMedia({
      audio: true,
      video: mode === 'video' ? { facingMode: 'user' } : false,
    });
  } catch {
    throw new Error(mode === 'video' ? 'Camera and microphone permission are required for video call.' : 'Microphone permission is required for voice call.');
  }
}
